import React from "react";
import './index.css'
import MatchCardGrid from "./components/MatchCard";


const GridMatchesView = ({matches})=>{
    return(
                    <div className="grid-matches-container" >
                        {
                            matches?.map(match =>{
                                return(<MatchCardGrid match={match} />)
                            })
                        }
                    </div>
    )
}

export default GridMatchesView